import type { ReactNode } from 'react';

export function Card({
  title,
  subtitle,
  children,
}: {
  title?: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <div className="card">
      {title && <h1 className="card-title">{title}</h1>}
      {subtitle && <p className="card-sub">{subtitle}</p>}
      {children}
    </div>
  );
}
